import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onStartConversation }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center bg-card">
      <div className="w-20 h-20 md:w-24 md:h-24 bg-primary/10 rounded-full flex items-center justify-center mb-4 md:mb-6">
        <Icon name="MessageCircle" size={40} color="var(--color-primary)" />
      </div>
      
      <h2 className="text-xl md:text-2xl font-heading font-semibold mb-2 md:mb-3">
        No Conversation Selected
      </h2>
      
      <p className="text-sm md:text-base text-muted-foreground mb-6 md:mb-8 max-w-md">
        Select a conversation from the list to start chatting, or discover new connections to begin messaging
      </p>

      <div className="space-y-4 w-full max-w-sm">
        <Button
          variant="default"
          fullWidth
          iconName="Search"
          iconPosition="left"
          onClick={onStartConversation}
        >
          Discover New Connections
        </Button>

        <div className="flex items-center gap-4">
          <div className="flex-1 h-px bg-border" />
          <span className="text-xs text-muted-foreground">Features</span>
          <div className="flex-1 h-px bg-border" />
        </div>

        <div className="space-y-3 text-left">
          <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
            <Icon name="Lock" size={18} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium mb-1">End-to-End Encryption</p>
              <p className="text-xs text-muted-foreground">Your messages are completely private and secure</p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
            <Icon name="Timer" size={18} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium mb-1">Disappearing Messages</p>
              <p className="text-xs text-muted-foreground">Set messages to automatically delete after viewing</p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
            <Icon name="ShieldAlert" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium mb-1">Screenshot Protection</p>
              <p className="text-xs text-muted-foreground">Automatic warnings prevent unauthorized captures</p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-3 bg-muted rounded-lg">
            <Icon name="Image" size={18} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium mb-1">Approval-Based Sharing</p>
              <p className="text-xs text-muted-foreground">Control who can view your shared media</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;